if(typeof _.range === 'undefined') { var e = new Error("Cannot find module '_.range'"); e.code = 'MODULE_NOT_FOUND'; throw e; }

module.exports = _.range;